import React, { HTMLAttributes, ReactChildren } from 'react';
import { Validation } from '../../../modules/dashboard/types';
import { validarCampo } from '../../validation/Validation';

export interface IError {
  erro: Partial<Validation>; // name do componente
  message: string; // mensagem de erro
  pattern: RegExp | string;
}

export interface IEvent {
  name: string;
  value: string;
}

export interface IInputProps
  extends Omit<
    HTMLAttributes<HTMLInputElement>,
    'onClick' | 'onBlur' | 'value'
  > {
  action: (event: IEvent, validate?: any) => void;
  actionBlur?: (event: IEvent, validate?: any) => void;
  cy: string;
  // We must dig deeper on the Error types
  required?: IError;
  left?: ReactChildren | string | JSX.Element;
  right?: ReactChildren | string | JSX.Element;
  type?: string;
  label?: string;
  name?: any;
  labelClass?: string;
  value: string | number;
  placeholder?: string;
}

export const Input: React.FC<IInputProps> = ({
  action = () => null,
  actionBlur,
  type = 'text',
  color = '',
  required,
  placeholder = '',
  cy = '',
  label,
  name = '',
  labelClass = '',
  value,
  ...props
}: IInputProps) => {
  // if (required) {
  //   const require = Object.keys(required)
  // }
  const pattern = (e: any) => {
    if (typeof required?.pattern === 'object') {
      return JSON.stringify(required.pattern);
    } else if (typeof required?.pattern === 'string') {
      return required.pattern;
    } else {
      return '';
    }
  };

  const validar = (e: any) => {
    const v = require.length ? validarCampo(e) : {};
    action(e.target, v);
  };

  const validarOnblur = (e: any) => {
    const v = require.length ? validarCampo(e) : {};
    if (actionBlur) actionBlur(e.target, v);
  };

  return (
    <div
      className={`form-box form-input ${color} ${
        required && (required.erro[name] ? 'erro' : '')
      } `}
    >
      {label ? (
        <label
          className="label-input"
          htmlFor={`id-${name}`}
          data-cy={`FormLabel${name}${cy}`}
        >
          {required && require.length ? (
            <span className="required-label">*</span>
          ) : (
            ''
          )}
          <span className={`input-label-span-text ${labelClass}`}>{label}</span>
        </label>
      ) : null}

      <div className={`input-${name}-wrapper input-wrapper`}>
        {props.left ? (
          <div className="input-actions-left">{props.left}</div>
        ) : null}
        <input
          {...props}
          data-cy={`FormInput${name}${cy}`}
          id={`id-${name}`}
          type={type}
          name={name}
          value={value}
          onChange={(e) => validar(e)}
          onBlur={(e) => validarOnblur(e)}
          pattern={pattern('')}
          placeholder={placeholder}
        />
        {props.right ? (
          <div className="input-actions">{props.right}</div>
        ) : null}
      </div>
      {required && required.erro?.[name] ? (
        <span className="campo-obrigatorio" data-cy={`FormError${name}${cy}`}>
          {required.message}
        </span>
      ) : null}
    </div>
  );
};
